// =============================================
// Shared text normalization utils for Content Engine
// Used by: outlineGenerator.ts, queryFanOut.ts
// =============================================

const DEDUP_STOP = new Set(["i", "a", "w", "z", "na", "do", "od", "o", "co", "to", "jest", "sie", "jak", "czy", "dla", "po", "ze", "za", "przy"]);
const DEDUP_PL: Record<string, string> = { "ą":"a","ć":"c","ę":"e","ł":"l","ń":"n","ó":"o","ś":"s","ź":"z","ż":"z" };

/** Normalize text for dedup: lowercase, strip PL diacritics, remove stop words + punctuation */
export function normalizeForDedup(text: string): string {
  return text
    .toLowerCase()
    .replace(/[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/g, (c) => DEDUP_PL[c.toLowerCase()] || c)
    .replace(/[?!.,;:'"()\[\]{}\-–—\/\\]/g, " ")
    .split(/\s+/)
    .filter((w) => w.length > 1 && !DEDUP_STOP.has(w))
    .join(" ")
    .trim();
}

/** Jaccard similarity between two normalized texts (token-level) */
export function jaccardSimilarity(a: string, b: string): number {
  const tokensA = new Set(a.split(/\s+/).filter(Boolean));
  const tokensB = new Set(b.split(/\s+/).filter(Boolean));
  if (tokensA.size === 0 || tokensB.size === 0) return 0;
  const intersection = [...tokensA].filter((t) => tokensB.has(t)).length;
  const union = new Set([...tokensA, ...tokensB]).size;
  return union > 0 ? intersection / union : 0;
}
